import { useState, useEffect } from 'react'
declare global {
	interface Window {
		Tawk_API?: {
			hideWidget?: () => void
			showWidget?: () => void
			onLoaded?: () => void
		}
	}
}
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'
import { Cookie, Shield, X } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function CookieConsent() {
	const [isVisible, setIsVisible] = useState(false)
	const { t } = useTranslation('common')

	useEffect(() => {
		const consent = localStorage.getItem('cookieConsent')
		if (!consent) {
			setTimeout(() => setIsVisible(true), 1000)
		}

		if (!consent) {
			const handleTawkHide = () => {
				if (window.Tawk_API && window.Tawk_API.hideWidget) {
					window.Tawk_API.hideWidget()
				}
			}

			handleTawkHide()

			if (window.Tawk_API && !window.Tawk_API.onLoaded) {
				window.Tawk_API.onLoaded = handleTawkHide
			}

			return () => {
				if (window.Tawk_API && window.Tawk_API.showWidget) {
					window.Tawk_API.showWidget()
				}
			}
		}
	}, [])

	const acceptCookies = () => {
		localStorage.setItem('cookieConsent', 'true')
		setIsVisible(false)
	}

	const declineCookies = () => {
		localStorage.setItem('cookieConsent', 'false')
		setIsVisible(false)
	}

	if (!isVisible) return null

	return (
		<>
			<div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4">
				<div className="bg-white rounded-xl max-w-md w-full shadow-2xl border border-gray-200 overflow-hidden animate-in fade-in-50 zoom-in-95 duration-300">
					<div className="h-1 w-full bg-blue-600"></div>

					<div className="absolute top-3 right-3">
						<Button variant="ghost" size="icon" onClick={declineCookies} className="h-8 w-8 rounded-full">
							<X className="h-4 w-4" />
						</Button>
					</div>

					<div className="p-6 pb-2">
						<div className="flex items-center gap-3 mb-4">
							<div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center">
								<Cookie className="h-5 w-5 text-blue-600" />
							</div>
							<h2 className="text-xl font-medium">{t('cookie-consent.title')}</h2>
						</div>

						<p className="text-sm text-gray-600 leading-relaxed">
							{t('cookie-consent.description')}{' '}
							<Link
								className="text-blue-600 underline underline-offset-4 hover:text-blue-800 transition-colors"
								href="/privacy-policy"
							>
								{t('cookie-consent.privacy-policy-link')}
							</Link>
							.
						</p>
					</div>

					<div className="px-6 py-3 bg-gray-100 mt-4 flex items-center gap-2">
						<Shield className="h-4 w-4 text-gray-500" />
						<p className="text-xs text-gray-500">{t('cookie-consent.privacy-note')}</p>
					</div>

					<div className="h-px w-full bg-gray-200"></div>

					<div className="p-4 flex flex-col sm:flex-row gap-2 justify-end">
						{/* <Button variant="outline" onClick={declineCookies} className="order-2 sm:order-1">
							{t('cookie-consent.decline-button', { fallback: 'Odrzuć' })}
						</Button> */}
						<Button variant="primaryBlue" onClick={acceptCookies} className="order-1 sm:order-2">
							{t('cookie-consent.accept-button')}
						</Button>
					</div>
				</div>
			</div>
			<style jsx global>{`
				body {
					overflow: hidden; /* Blokuje przewijanie */
				}
				/* Upewniamy się, że inne elementy z wysokim z-index są ukryte gdy modal jest otwarty */
				.fixed-overlay {
					position: relative;
					z-index: 9999;
				}
			`}</style>
		</>
	)
}
